import { atom } from 'jotai';

export const banksOptionAtom = atom<
  Array<{
    value: string;
    bankname: string;
  }>
>([]);

export const invalidBankAtom = atom<boolean>(false);

export const selectedBankingOptionAtom = atom<string>('');
